import { useEffect, useState } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFadeOut(true), 3000);
    const t2 = setTimeout(() => onComplete(), 3600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onComplete]);

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'linear-gradient(160deg, #7c8cf5 0%, #6d5fbf 50%, #8b5fbf 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      opacity: fadeOut ? 0 : 1,
      transition: 'opacity 0.6s ease-out',
    }}>
      <style>{`
        @keyframes spin-pulse {
          0% { transform: rotate(0deg) scale(1); opacity: 0.9; }
          50% { transform: rotate(180deg) scale(1.1); opacity: 1; }
          100% { transform: rotate(360deg) scale(1); opacity: 0.9; }
        }
        @keyframes ring-expand {
          0% { transform: scale(0.8); opacity: 0.6; }
          50% { transform: scale(1.15); opacity: 0; }
          100% { transform: scale(0.8); opacity: 0.6; }
        }
      `}</style>

      {/* Pulsing ring */}
      <div style={{
        position: 'absolute',
        width: 80,
        height: 80,
        borderRadius: '50%',
        border: '2px solid rgba(255,255,255,0.25)',
        animation: 'ring-expand 2s ease-in-out infinite',
      }} />

      {/* Spinning loader */}
      <div style={{
        width: 40,
        height: 40,
        borderRadius: '50%',
        border: '3px solid rgba(255,255,255,0.15)',
        borderTopColor: 'rgba(255,255,255,0.9)',
        animation: 'spin-pulse 1.2s ease-in-out infinite',
      }} />
    </div>
  );
};

export default SplashScreen;
